import { AxiosResponse } from "axios";
import {
  IProjectConfigurationResponseData,
  IProjectCategoriesResponseData,
  IStudioCategory,
  IStudioStage,
  IProduct,
} from "../../redux/reducers/ui/uiTypes";
import { ISearchProjectsResponseData } from "../../redux/reducers/ui/uiTypes";
import { adminAxiosInstance } from "./instances";
import { ENDPOINTS } from "./endpoints";

export const getProjectAPI = async (
  organizationId: number
): Promise<AxiosResponse<IProjectConfigurationResponseData>> => {
  return await adminAxiosInstance.get(
    `${ENDPOINTS.STUDIO.PROJECT_CONFIGURATION}/${organizationId}/stages?page=1&pageSize=25`
  );
};

export const getProjectStagesAPI = async (
  stageId: number
): Promise<AxiosResponse<IStudioStage>> => {
  return await adminAxiosInstance.get(
    `${ENDPOINTS.STUDIO.RETRIEVE_STAGES}/${stageId}`
  );
};

export const getCategoriesAPI = async (
  organizationId: number
): Promise<AxiosResponse<IProjectCategoriesResponseData>> => {
  return await adminAxiosInstance.get(
    `${ENDPOINTS.STUDIO.PROJECT_CATEGORIES}?organizationId=${organizationId}&parentId=null`
  );
};

export const getCategoryFolderAPI = async (
  categoryId: number
): Promise<AxiosResponse<IStudioCategory>> => {
  return await adminAxiosInstance.get(
    `${ENDPOINTS.STUDIO.RETRIEVE_CATEGORIES}/${categoryId}`
  );
};

export interface IProductsResponseData {
  count: number;
  rows: IProduct[];
}

export const getProductsAPI = async (
  projectId: number
): Promise<AxiosResponse<IProductsResponseData>> => {
  return await adminAxiosInstance.get(
    `/products?page=1&pageSize=500&projectId=${projectId}`
  );
};

export const searchForProduct = async (
  title: string
): Promise<AxiosResponse<ISearchProjectsResponseData>> => {
  return await adminAxiosInstance.get(
    `/projects?pageSize=500&searchByName=${title}`
  );
};
